export interface Testimonial {
  name: string;
  content: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    name: "",
    content: "I've been using the paid version of Clarymind for over a month now. I started because I wanted to reduce the anxiety that comes from too much social media. So far, it's been pretty effective at cutting down my time on social platforms.\n\n（Shared on personal account）",
    rating: 5
  },
  {
    name: "",
    content: "I am much focused after not scrolling for hours. Love the gentle way it says do you really want to do this, if you try and use the app!",
    rating: 5
  },
  {
    name: "",
    content: "After locking Twitter, I sometimes go the whole day without opening it. Compared to before, I save about 16 hours a week.",
    rating: 5
  },
  {
    name: "",
    content: "An app to help you reconnect with real life! If you can't stop scrolling social media every day and always regret wasting time, it might not be about lacking willpower. You could just be missing the right tool.",
    rating: 5
  },
  {
    name: "",
    content: "It not only saves me time, but also reduces the anxiety that I was unconsciously taking in while scrolling Instagram. Thank you Clarymind 🤍",
    rating: 5
  },
  {
    name: "",
    content: "I am someone diagnosed with ADHD and have been looking into reducing my impulsive shopping habits and screen time as a new year resolution. I randomly found this app and didn’t think much of it at first. But it was a nice surprise to find that not only was it very cute but it’s actually thoughtful in implementing the exercises and ways to block the apps.",
    rating: 5
  },
  {
    name: "",
    content: "Clarymind extends the time it takes to open social media apps and shows thoughtful prompts during the wait. It's really helped me cut down on mindlessly seeking social stimulation.",
    rating: 5
  },
  {
    name: "",
    content: "What really helps me are the reflective quotes after each breathing session and the flexibility to adjust how many times and how long I can use apps each day.\n\nUnlike other apps, Clarymind gives me more freedom, making it easier for me to stick to the limits I set for myself.\n\n(Shared on personal account)",
    rating: 5
  },
  {
    name: "",
    content: "Screen Time AI is amazing! It's such a great tool, incorporating the mindful 'pause' concept to help users become more aware of what they're about to do. This approach is really helpful for breaking unconscious habits!",
    rating: 5
  },
  {
    name: "",
    content: "Allowing only short bursts of screen time really helps stop mindless scrolling. It's awesome!",
    rating: 5
  },
  {
    name: "",
    content: "I’ve tried several mindfulness apps, like meditation, screen-off tree planting, and Pomodoro timers, but none have been as effective as Clarymind.\n\n(Shared on personal account)",
    rating: 5
  },
  {
    name: "",
    content: "Before opening Instagram, I always ask myself if it's really necessary. And even if I forget my original intention, the app still locks after the set time.",
    rating: 5
  },
  {
    name: "",
    content: "Clarymind is undoubtedly an app that everyone can use in modern society.",
    rating: 5
  },
  {
    name: "",
    content: "When experiencing intense emotional fluctuations, you can use Clarymind's “Breath” feature to help calm your emotions.",
    rating: 5
  },
  {
    name: "",
    content: "The app offers various white noises, animal sounds, rain sounds, crackling fire sounds, and more, which are incredibly useful when trying to sleep at daytime during night shift!",
    rating: 5
  },
  {
    name: "",
    content: "Nice meditation music, easy to start meditation any time! The app locking function is surprisingly effective!",
    rating: 5
  },
  {
    name: "",
    content: "This app has significantly reduced my social media usage time. It's not forceful at all. Instead, it gently reminds you before you open social media: 'Is this really what you need?' I think that moment of awareness is enough to break the automatic habit of opening apps and scrolling through short videos!!",
    rating: 5
  },
  {
    name: "",
    content: "If you're looking for a focus assistance app that suits you, I personally think Clarymind is perfect. It can even help redirect to other applications.\n\nPlus, the customer service is excellent! It's not one of those apps where they just write the code and abandon it. Last week, I found that the app I wanted couldn't redirect, so I contacted customer service with feedback. The next week, they immediately added it!",
    rating: 5
  },
  {
    name: "",
    content: "Time is the most important thing in life, and the tech giants are using human attention to create greater wealth. People are becoming increasingly unhappy while spending too much time on social media.\n\nThis app helps you reduce the urge to use your phone and help you regain a peaceful life. I was originally using a Korean app, which I also thought was good, but this one is more complete and more relaxing!",
    rating: 5
  },
  {
    name: "",
    content: "Definitely worth downloading and subscribing! It effectively helps you reclaim time from social media and makes you reflect on the necessity of using social media. The design is truly excellent!",
    rating: 5
  },
  {
    name: "",
    content: "This is an ideal app that I wish I had discovered sooner. The first impression was fantastic, even the background music is very comfortable. The quality difference compared to other apps is significant. This is definitely an app worth downloading.",
    rating: 5
  }
];